import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Onboarding from './pages/Onboarding';
import Sites from './pages/Sites';
import Translations from './pages/Translations';
import BillingEnhanced from './pages/BillingEnhanced';
import Pricing from './pages/Pricing';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCanceled from './pages/CheckoutCanceled';
import Glossaries from './pages/Glossaries';
import GlossaryEditor from './pages/GlossaryEditor';
import TranslationMemory from './pages/TranslationMemory';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/home" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/pricing" element={<Pricing />} />

            {/* Onboarding Route (Protected) */}
            <Route path="/onboarding" element={
              <ProtectedRoute>
                <Onboarding />
              </ProtectedRoute>
            } />

            {/* Protected Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              {/* Dashboard home */}
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />

              {/* Sites routes */}
              <Route path="sites" element={<Sites />} />
              <Route path="sites/:siteId/translations" element={<Translations />} />

              {/* Global translations route */}
              <Route path="translations" element={<Translations />} />

              {/* Billing routes */}
              <Route path="billing" element={<BillingEnhanced />} />
              <Route path="billing/success" element={<CheckoutSuccess />} />
              <Route path="billing/canceled" element={<CheckoutCanceled />} />

              {/* Glossary routes */}
              <Route path="glossaries" element={<Glossaries />} />
              <Route path="glossaries/:glossaryId" element={<GlossaryEditor />} />

              {/* Translation Memory route */}
              <Route path="translation-memory" element={<TranslationMemory />} />

              {/* Placeholder routes */}
              <Route path="languages" element={
                <div className="text-center py-12">
                  <h1 className="text-2xl font-bold text-gray-900">Languages</h1>
                  <p className="text-gray-600">Language management coming soon...</p>
                </div>
              } />
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
